import { PAD_VISIT_TYPE } from 'app/config/padVisits';

export const checkSuspensionVisit = padVisit => {
  const { padVisitType } = padVisit;
  const isSuspension = padVisitType === PAD_VISIT_TYPE.SUSPENSION;

  return isSuspension;
};
